import { ReducerBase } from "common/reducer";
import initialState from "app/initialState";
import ApiProgress from "./apiProgress";
import { ApiCallStarted, ApiCallFailed, ApiCallSucceeded, ApiCallCheckStatus } from "./saveIndicator.actions";


export class ApiProgressReducer extends ReducerBase<ApiProgress> {
  constructor() {
    super();
    this.addHandler(ApiCallStarted.EventName, this.handleApiCallStarted);
    this.addHandler(ApiCallSucceeded.EventName, this.handleApiCallSucceeded);
    this.addHandler(ApiCallFailed.EventName, this.handleApiCallFailed);
    this.addHandler(ApiCallCheckStatus.EventName, this.handleCheckApiCallStatus);
  }

  handleApiCallStarted(state: ApiProgress = initialState.apiProgress, event: ApiCallStarted): ApiProgress {
    return { ...state, activeCalls: state.activeCalls + 1, isComplete: false };
  }

  handleApiCallSucceeded(state: ApiProgress = initialState.apiProgress, event: ApiCallSucceeded): ApiProgress {
    return { ...state, activeCalls: state.activeCalls - 1, lastSaved: new Date() };
  }

  handleApiCallFailed(state: ApiProgress = initialState.apiProgress, event: ApiCallFailed): ApiProgress {
    return { ...state, activeCalls: state.activeCalls - 1 };
  }

  handleCheckApiCallStatus(state: ApiProgress = initialState.apiProgress, event: ApiCallCheckStatus): ApiProgress {
    return { ...state, activeCalls: state.activeCalls, isComplete: state.activeCalls < 1 };
  }

  handleDefault(state: ApiProgress = initialState.apiProgress) {
    return state;
  }
}



